import { ITwrDeviceBackend } from '@app/@types/scenes/scenesDevices'

const filterTwrKeyfobForCondition = (devices: Array<ITwrDeviceBackend>):
  Array<ITwrDeviceBackend> => devices.filter((device) => device.device_type !== 'Keyfob')

export default filterTwrKeyfobForCondition
